import { BaseItem, Column, InternalData } from '../VirtualizedTable.types';

export interface UseVirtualizedCardTableParams<T extends BaseItem> {
  item: InternalData<T>;
  itemIndex: number;
  columns: Column<T>[];
  isFirstLoading?: boolean;
  onClickAction?: (event: React.MouseEvent<HTMLButtonElement>, item: T) => void;
}

const useVirtualizedCardTable = <T extends BaseItem>({
  item,
  itemIndex,
  columns,
  isFirstLoading = false,
  onClickAction,
}: UseVirtualizedCardTableParams<T>) => {
  const handleClickAction = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (!onClickAction) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    onClickAction(event, item);
  };

  const cardColumns = [...columns];

  const mainColumnDefinition = cardColumns.shift();
  const mainColumn =
    mainColumnDefinition && !isFirstLoading
      ? (mainColumnDefinition.cardRender ?? mainColumnDefinition.render)(item, itemIndex)
      : undefined;

  const topRightElementIndex = cardColumns.findIndex((column) => column.xs?.useAtTheTopRight);

  const topRightElement: Column<T> | undefined =
    topRightElementIndex >= 0 ? cardColumns.splice(topRightElementIndex, 1)[0] : undefined;

  const [chipColumns, bodyColumns] = cardColumns.reduce<[Column<T>[], Column<T>[]]>(
    ([chips, body], column) => {
      if (column.xs?.showAsCardChip) {
        chips.push(column);
      } else {
        body.push(column);
      }
      return [chips, body];
    },
    [[], []],
  );

  return {
    handleClickAction,
    mainColumn,
    chipColumns,
    bodyColumns,
    topRightElement,
  };
};

export default useVirtualizedCardTable;
